<template lang="pug">
    div
        // p params
        //- code {{ $route.params }}
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col
                    div(style="display: flex; flex-direction: row")
                        Icon.returnBtn(@click="goBackBtn" type="ios-arrow-back" size="32")
                        h2 {{$t('groupresource.appProfileUsage')}} {{ $route.params.appProfileName }}
                Col
                    getResourceBtn(
                            permissionKey="domainManagePermission"
                            :title="$route.params.appProfileName"
                            endPoint="app-profiles"
                            :docId="`${$store.state.queryGroupName}-${$route.params.appProfileName}`"
                            :groupName="$store.state.queryGroupName"
                            :renderFields="renderFields"
                            managePageName= "AppProfile",
                            keyField="appProfileName",
                            buttonText=""
                            icon="md-eye")
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :userCanBatchEdit="true"
            :userCanBatchDelete="true"
            :userCanSearchByTag="true"
            :drawerTitleKey="drawerTitleKey"
            ref="rcmTable"
            :searchView="searchView"
            :sectionInfo="sectionInfo"
            primarySearchKey="servername"
            :primarySearchKeyI18="$t('domainsetting.servername')"
            :batchSelector="batchSelector"
            :batchSelectorWith="batchSelectorWith"
            :givenBatchSearchFilters="givenBatchSearchFilters"
            :isCreateBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isEditBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isDeleteBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isBatchEditBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :isBatchDeleteBtnDisabled="!$can('write', 'domainManagePermission','FQDNConfig')"
            :withAfterBulkCreateModal="$store.getters.getDomainConfig.canBulkCreate"
            @showAfterBulkCreateModal="showCnameInfo = $event"
            @passDomainList="domainList = $event"
        )
            template(slot="tableUpperBtn")
                Button.left-under-table-btn(
                    :disabled="!$can('write', 'domainManagePermission','FQDNConfig')"
                    @click="isBatchClearCacheFormShown = true"
                ) {{$t('cacheClear.addBtnText')}}

        // batch清緩存
        Drawer(title="Batch Purge" v-model="isBatchClearCacheFormShown" width="70" :styles="formDrawerStyles")
            BatchClearCacheForm(
                :esIndex="esIndex"
                :batchSelector="batchSelector"
                v-if="isBatchClearCacheFormShown"
                @batchSubmitComplete="isBatchClearCacheFormShown = false"
                :batchSelectorWith="batchSelectorWith"
                :givenBatchSearchFilters="givenBatchSearchFilters")

        OriginPolicyOriginsModal(ref="originPolicyModal" searchView="OriginPolicy")
        //- Modal(v-model="showCnameInfo" :title="$t('domainsetting.cnameHintTitle')")
        //-     span {{$t("domainsetting.cnameHintContent")}}
        //-     br
        //-     span ex: www.domain.com CNAME to www.domain.com.{{rootDomain}}
        //-     br
        //-     br
        //-     List(border)
        //-         ListItem(v-for="(item, index) in domainList" :key="index")
        //-             ListItemMeta(:title="item.cnameHint")
        //-             template(slot="action")
        //-                 li
        //-                     RawHtml(:formData="item" :formKey="'cnameHtml'")
        //-     div(slot="footer")
        //-         Button(type="primary" @click="showCnameInfo = false") OK
</template>
<script>
import Vue from "vue";
import { _dateFormat } from "@/libs/dateformat.js";
import { _getResource } from "@/api/rest/index.js";

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import bus from "@/libs/bus.js";
import BatchClearCacheForm from "@/components/BatchClearCacheForm";
import FQDNSelector from "@/components/FQDNSelector";
import RawHtml from "@/components/rcmTableFormItems/RawHTML";

import CopyText from "@/components/CopyText";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import checkCname from "@/components/checkCname";
import DomainCertPoptip from "@/components/FormItems/DomainCertPoptip.vue";
import ExplainServername from "@/components/PoptipInfos/ExplainServername";
import OriginPolicyOriginsModal from "@/components/OriginPolicyOriginsModal.vue";

import { boolToIcons, boolToColors } from "@/libs/rcmTableFieldsFunction";

import {
    settingZoneExplain,
    groupName,
    keypairname,
    appProfileName,
    isEnforceProtectWithPaw,
    isEnforceProtectWithSwitch,
    origins,
    originscheme,
    portMappingType,
    originPort,
    hasSystemCert,
    description,
    action,
} from "./fields.js";

Vue.component("TagList", TagList);
Vue.component("CopyText", CopyText);
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("checkCname", checkCname);
Vue.component("DomainCertPoptip", DomainCertPoptip);
Vue.component("ExplainServername", ExplainServername);

export default {
    name: "ProfileDomain",
    components: { RcmTable, TagList, BatchClearCacheForm, FQDNSelector, RawHtml, OriginPolicyOriginsModal },
    data() {
        return {
            showCnameInfo: false,
            domainList: [],
            rootDomain: "",
            batchSelector: "FQDNSelector",
            batchSelectorWith: ["groupName", "appProfileName", "servername"],
            givenBatchSearchFilters: [
                {
                    key: "groupName",
                    type: "string",
                    value: this.$store.state.queryGroupName,
                },
                {
                    key: "appProfileName",
                    type: "string",
                    value: this.$route.params.appProfileName,
                },
            ],
            searchView: "ProfileDomain",
            esIndex: "rcm-nginxconfigs",
            drawerTitleKey: "servername",
            isBatchClearCacheFormShown: false,
            formDrawerStyles: {
                height: "calc(100% - 120px)",
                overflow: "auto",
                paddingBottom: "53px",
                position: "static",
            },
            appProfileData: {}
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("domainsetting.createText");
        },
        renderFields() {
            const fields = [
                { key: "groupName", title: this.$i18n.t("domainsetting.groupName") },
                { key: "appProfileName", title: this.$i18n.t("domainsetting.appProfileName") },
                { key: "serviceGroupName", title: this.$i18n.t("domainsetting.serviceGroupName") },
                {
                    key: "useOriginPolicy",
                    title: this.$i18n.t("domainsetting.useOriginPolicy"),
                    render: (h, params) => {
                        var iconType = boolToIcons({
                            value: params.useOriginPolicy,
                            falseToDash: false,
                        });
                        var iconColor = boolToColors({
                            value: params.useOriginPolicy,
                            falseToGrey: false,
                        });

                        return h("Icon", {
                            props: {
                                type: iconType,
                                color: iconColor,
                                size: 24,
                            },
                        });
                    },
                },
                { key: "origins", title: this.$i18n.t("domainsetting.origins") },
                { key: "originscheme", title: this.$i18n.t("domainsetting.originscheme") },
                { key: "portMappingType", title: this.$i18n.t("domainsetting.portMappingType") },
                { key: "originPort", title: this.$i18n.t("domainsetting.originPort") },
                { key: "scheme", title: this.$i18n.t("domainsetting.scheme") },
                { key: "httpPort", title: this.$i18n.t("domainsetting.httpPort") },
                { key: "httpsPort", title: this.$i18n.t("domainsetting.httpsPort") },
                {
                    key: "usedWafRules",
                    title: this.$i18n.t("domainsetting.usedWafRules"),
                    render: (h, params) => {
                        let wafrules = params.usedWafRules ? params.usedWafRules : [];
                        var enabledWafrules = wafrules.filter((e) => e.isEnabled == true);

                        var iconType = boolToIcons({
                            value: enabledWafrules.length > 0,
                            falseToDash: true,
                        });
                        var iconColor = boolToColors({
                            value: enabledWafrules.length > 0,
                            falseToGrey: true,
                        });

                        if (enabledWafrules.length > 0) {
                            return h(
                                "div",
                                enabledWafrules.map(function (e) {
                                    return h(
                                        "p",
                                        {
                                            props: {},
                                        },
                                        `${e.value}`
                                    );
                                })
                            );
                        } else {
                            return h("Icon", {
                                props: {
                                    type: iconType,
                                    color: iconColor,
                                    size: 24,
                                },
                            });
                        }
                    },
                },
                { key: "errorHtmlPageName", title: this.$i18n.t("domainsetting.errorHtmlPageName") },
                { key: "upstreamTimeout", title: this.$i18n.t("domainsetting.upstreamTimeout") },
                { key: "isEnabledCompressionToOrigin", title: "Upstream Compression" },
                { key: "isEnabledUpstreamHttp11", title: "Upstream HTTP/1.1" },
                { key: "isInsertRidHeaderToOrigin", title: "Insert RID" },
                { key: "setCustomHostHeader", title: this.$i18n.t("domainsetting.setCustomHostHeader") },
                { key: "isAcceptHttpV1", title: this.$i18n.t("domainsetting.isAcceptHttpV1") },
                { key: "keypairname", title: this.$i18n.t("domainsetting.keypairname") },
                { key: "redirectHttpCode", title: this.$i18n.t("domainsetting.redirectHttpCode") },
                {
                    key: "useHsts",
                    title: this.$i18n.t("domainsetting.useHsts"),
                    render: (h, params) => {
                        var iconType = boolToIcons({
                            value: params.useHsts,
                            falseToDash: false,
                        });
                        var iconColor = boolToColors({
                            value: params.useHsts,
                            falseToGrey: false,
                        });

                        return h("Icon", {
                            props: {
                                type: iconType,
                                color: iconColor,
                                size: 24,
                            },
                        });
                    },
                },
                {
                    key: "useHttp2",
                    title: this.$i18n.t("domainsetting.useHttp2"),
                    render: (h, params) => {
                        var iconType = boolToIcons({
                            value: params.useHttp2,
                            falseToDash: false,
                        });
                        var iconColor = boolToColors({
                            value: params.useHttp2,
                            falseToGrey: false,
                        });

                        return h("Icon", {
                            props: {
                                type: iconType,
                                color: iconColor,
                                size: 24,
                            },
                        });
                    },
                },
                {
                    key: "useSystemCert",
                    title: this.$i18n.t("domainsetting.useSystemCert"),
                    render: (h, params) => {
                        var iconType = boolToIcons({
                            value: params.useSystemCert,
                            falseToDash: false,
                        });
                        var iconColor = boolToColors({
                            value: params.useSystemCert,
                            falseToGrey: false,
                        });

                        return h("Icon", {
                            props: {
                                type: iconType,
                                color: iconColor,
                                size: 24,
                            },
                        });
                    },
                },
                {
                    key: "useTlsv13",
                    title: this.$i18n.t("domainsetting.useTlsv13"),
                    render: (h, params) => {
                        var iconType = boolToIcons({
                            value: params.useTlsv13,
                            falseToDash: false,
                        });
                        var iconColor = boolToColors({
                            value: params.useTlsv13,
                            falseToGrey: false,
                        });

                        return h("Icon", {
                            props: {
                                type: iconType,
                                color: iconColor,
                                size: 24,
                            },
                        });
                    },
                },
                { key: "createBy", title: this.$i18n.t("domainsetting.createBy") },
                {
                    key: "createdDate",
                    title: this.$i18n.t("domainsetting.createdDate"),
                    render: (h, params) => {
                        return h("div", _dateFormat(params.createdDate, "YYYY-MM-DD HH:mm:ss"));
                    },
                },
                {
                    key: "modifiedDate",
                    title: this.$i18n.t("domainsetting.modifiedDate"),
                    render: (h, params) => {
                        return h("div", _dateFormat(params.modifiedDate, "YYYY-MM-DD HH:mm:ss"));
                    },
                },
            ];
            // 如果有使用origin policy，則顯示被使用的origin policy列表
            if (this.appProfileData.useOriginPolicy === true) {
                const usedOriginPoliciesField = {
                    key: "usedOriginPolicies",
                    title: this.$i18n.t("domainsetting.usedOriginPolicies"),
                    render: (h, params) => {
                        const usedOriginPolicies = params.usedOriginPolicies || [];
                        if (usedOriginPolicies.length > 0) {
                            return h(
                                "div",
                                {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column"
                                    }
                                },
                                usedOriginPolicies.map(originPolicy =>
                                    h("div", [
                                        h(
                                            "span",
                                            {
                                                class: "linkBtn",
                                                on: {
                                                    click: () =>
                                                        this.$refs.originPolicyModal.open(
                                                            params.groupName,
                                                            originPolicy.originPolicyName
                                                        )
                                                }
                                            },
                                            originPolicy.originPolicyName
                                        )
                                    ])
                                )
                            );
                        }
                    }
                };
                fields.splice(4, 0, usedOriginPoliciesField);
            }

            return fields;
        },
        sectionInfo() {
            let sectionInfo = [
                { sectionKey: "essential", isOpened: true },
                { sectionKey: "http_https", isOpened: false },
                { sectionKey: "wafrules", isOpened: false },
                { sectionKey: "advanced", isOpened: false },
            ];

            sectionInfo = sectionInfo.map((e) => {
                e.sectionName = this.$i18n.t(`domainsetting.sections.${e.sectionKey}`);
                return e;
            });

            return sectionInfo;
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: action(this),
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      appProfileName: appProfileName(this),
                      _id: {},
                      servername: {},
                      origins: origins(this),
                      originscheme: originscheme(this),
                      portMappingType: portMappingType(this),
                      originPort: originPort(this),
                      description: description(this),
                      cnameHint: {},
                      hasSystemCert: hasSystemCert(this),
                      useSystemCert: {},
                      sslProvider: {},
                      keypairname: keypairname(this),
                      isAllowOCSP: {},
                      tags: {},
                      isEnforceProtect: this.$store.getters.getDomainConfig.isEnforceProtectWithPaw
                          ? isEnforceProtectWithPaw(this)
                          : isEnforceProtectWithSwitch(this),
                      currentCname: {},
                      cnameInfo: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      platformVersion: {},
                      objectLog: {},
                  }
                : {
                      action: action(this),
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      appProfileName: appProfileName(this),
                      _id: {},
                      servername: {},
                      servername: {},
                      origins: origins(this),
                      originscheme: originscheme(this),
                      portMappingType: portMappingType(this),
                      originPort: originPort(this),
                      description: description(this),
                      cnameHint: {},
                      hasSystemCert: hasSystemCert(this),
                      useSystemCert: {},
                      sslProvider: {},
                      keypairname: keypairname(this),
                      isAllowOCSP: {},
                      tags: {},
                      currentCname: {},
                      cnameInfo: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      platformVersion: {},
                      objectLog: {},
                  };
        },
    },
    methods: {
        goBackBtn() {
            this.$router.push({ name: "AppProfile" });
        },
    },
    watch: {
        "$store.state.rcmTableIsInitComplete": function (newVal, oldVal) {
            if (this.$router.currentRoute.query.create && newVal) {
                this.$refs.rcmTable.manipulateItem("", "create");
            }
        },
    },
    mounted() {
        // var self = this;
        // setTimeout(function () {
        //     self.rootDomain = self.$refs.rcmTable.getEsResult.cnameRootDomain;
        // }, 2000);
    },
    async created() {
        this.$bus = bus;
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent, args) => {
            // 如果是找我的事件就接收處理, 否則向下傳遞
            switch (busEvent) {
                case "":
                    break;
                default:
                    bus.$emit(busEvent);
                    break;
            }
        });
        await _getResource(
            "app-profiles",
            `${this.$store.state.queryGroupName}-${this.$route.params.appProfileName}`,
            this.$store.state.queryGroupName
        ).then((result) => {
            this.appProfileData = result.data.data;
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/ProfileDomain/Page.vue